import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = {
  key: 7,
  class: "dataTable"
}
const _hoisted_4 = { style: {"margin-bottom":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_AttachmentModal = _resolveComponent("AttachmentModal")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!
  const _component_ModalCardConfirm = _resolveComponent("ModalCardConfirm")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('devis.request.singlePage.title')) + " " + _toDisplayString(this.$route.params.id), 1),
      _createVNode(_component_ReglePastille, { cle: "demandeDevis.definition" }),
      _createVNode(_component_ReglePastille, { cle: "demandeDevisSuivi.modificationLimitee" })
    ]),
    _createVNode(_component_BorderedIconButton, {
      title: "RETOUR",
      imgUrl: _ctx.imgUrl,
      className: "back-btn",
      onClick: this.$router.back
    }, null, 8, ["imgUrl", "onClick"]),
    (this.demandeDevisData)
      ? (_openBlock(), _createBlock(_component_DataList, {
          key: 0,
          data: this.demandeDevisData
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    (_ctx.isEnAttente)
      ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
          key: 1,
          title: _ctx.$t('button.edit'),
          imgUrl: _ctx.editImgUrl,
          className: "btn-modifier",
          onClick: _ctx.openEditEstimate
        }, null, 8, ["title", "imgUrl", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.isEnAttente)
      ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
          key: 2,
          title: _ctx.$t('bouton.supprimer'),
          imgUrl: _ctx.deleteImgUrl,
          className: "btn-supprimer",
          onClick: _ctx.openDeleteModal
        }, null, 8, ["title", "imgUrl", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.attachment)
      ? (_openBlock(), _createBlock(_component_AttachmentModal, {
          key: 3,
          data: _ctx.attachment,
          "content-type": _ctx.contentType,
          onClose: _ctx.closeModal
        }, null, 8, ["data", "content-type", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isAttachmentLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 4 }))
      : _createCommentVNode("", true),
    (_ctx.showDeleteSuccessModal)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 5,
          onCancel: _ctx.closeDeleteSuccess,
          subtitle: _ctx.$t('devis.request.delete.success', { id: this.$route.params.id }),
          title: ''
        }, null, 8, ["onCancel", "subtitle"]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 6,
          onCancel: _ctx.closeDeleteModal
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCardConfirm, {
              headerTitle: _ctx.$t('devis.deleteModal.title', { id: this.$route.params.id }),
              activeValidate: true,
              onConfirm: _ctx.deleteDemande,
              onCancel: _ctx.closeDeleteModal
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('devis.request.deleteConfirm')), 1)
              ]),
              _: 1
            }, 8, ["headerTitle", "onConfirm", "onCancel"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.demandeDevis == null || _ctx.demandeDevis.devis == null ? 0 : _ctx.demandeDevis.devis?.length) + " " + _toDisplayString(_ctx.$t('devis.request.singlePage.devis.title')), 1)
          ]),
          (_ctx.isLoaded)
            ? (_openBlock(), _createBlock(_component_DataTable, {
                key: 0,
                count: _ctx.demandeDevis.devis?.length,
                "table-header": _ctx.tableDevisHeader,
                "table-data": _ctx.devisTableData,
                onSelect: _ctx.goToPage
              }, null, 8, ["count", "table-header", "table-data", "onSelect"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}